import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c79ca10"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-xl font-bold mb-4" }, "Password Generator", -1))
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "length",
  class: "block mb-2"
}, "Length:", -1))
const _hoisted_5 = { class: "mb-4 space-y-2" }
const _hoisted_6 = { class: "flex items-center text-slate-300" }
const _hoisted_7 = { class: "flex items-center text-slate-300" }
const _hoisted_8 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_9 = { class: "p-2 rounded inline-block bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-100 border border-slate-200 dark:border-slate-700" }
const _hoisted_10 = {
  key: 1,
  class: "snackbar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _withDirectives(_createElementVNode("input", {
        type: "number",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.passwordLength) = $event)),
        min: "6",
        max: "20",
        class: "w-full px-3 py-2 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50"
      }, null, 512), [
        [
          _vModelText,
          _ctx.passwordLength,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.includeNumbers) = $event)),
          class: "mr-2 w-4 h-4 bg-slate-800 border-slate-600 rounded text-primary-600 focus:ring-primary-500"
        }, null, 512), [
          [_vModelCheckbox, _ctx.includeNumbers]
        ]),
        _createTextVNode(" Include Numbers ")
      ]),
      _createElementVNode("label", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.includeSymbols) = $event)),
          class: "mr-2 w-4 h-4 bg-slate-800 border-slate-600 rounded text-primary-600 focus:ring-primary-500"
        }, null, 512), [
          [_vModelCheckbox, _ctx.includeSymbols]
        ]),
        _createTextVNode(" Include Symbols ")
      ])
    ]),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.generatePassword && _ctx.generatePassword(...args))),
      class: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
    }, " Generate Password "),
    (_ctx.generatedPassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createTextVNode(" Generated Password: "),
            _createElementVNode("strong", null, _toDisplayString(_ctx.generatedPassword), 1)
          ]),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyPassword && _ctx.copyPassword(...args))),
            class: "bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ml-2"
          }, " Copy ")
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSnackbar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Password copied to clipboard! "))
      : _createCommentVNode("", true)
  ]))
}